import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";

import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import NavigationResourceLoader from "./components/NavigationResourceLoader/NavigationResourceLoader";
import TestApi from "./components/TestApi";
import "./index.css";

import Login from "./components/Login/Login";
import DashboardLayout from "./components/Dashboard/DashboardLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./components/NotFound";

import ContentPage from "./components/Dashboard/Content/ContentPage";
import Bookings from "./components/Dashboard/Bookings/Bookings";
import ContactMessages from "./components/Dashboard/Contact/ContactMessages";


const Home = lazy(() => import("./pages/Home/Home"));
const About = lazy(() => import("./pages/About/About"));
const DoctorDetails = lazy(() =>
  import("./pages/DoctorDetails/DoctorDetails")
);
const Services = lazy(() => import("./pages/Services/Services"));
const ServiceDetails = lazy(() =>
  import("./pages/ServiceDetails/ServiceDetails")
);
const ProtocolDetail = lazy(() => import("./pages/Services/ProtocolDetail"));
const Schedule = lazy(() => import("./pages/Schedule/Schedule"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Devices = lazy(() => import("./pages/Devices/Devices"));
const DeviceDetail = lazy(() => import("./pages/Devices/DeviceDetail"));
const PrivacyPolicy = lazy(() => import("./pages/Legal/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/Legal/TermsOfService"));



const Users = lazy(() => import("./components/Dashboard/Users"));

function App() {
  return (
    <>
      <NavigationResourceLoader />
      <Suspense fallback={null}>
        <ScrollToTop />
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/meet-doctor" element={<DoctorDetails />} />
          <Route path="/meet-doctor/:slug" element={<DoctorDetails />} />
          <Route path="/doctors" element={<Navigate to="/meet-doctor" replace />} />
          <Route path="/doctors/:slug" element={<Navigate to="/meet-doctor" replace />} />
          <Route path="/services" element={<Services />} />
          <Route
            path="/services/protocol/:protocolId"
            element={<ProtocolDetail />}
          />
          <Route path="/services/:slug" element={<ServiceDetails />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/devices/:deviceId" element={<DeviceDetail />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />

          <Route path="/mandarinadmin" element={<Login />} />
          <Route path="/test" element={<TestApi />} />
          <Route path="/notfound" element={<NotFound />} />


          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >

            <Route path="users" element={<Users />} />
            <Route path="content" element={<ContentPage />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="contactmessages" element={<ContactMessages />} />
          </Route>


          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
